import { createFileRoute } from '@tanstack/react-router';

import CarfTransmissionDetailPage from '../../../components/transmissions/CarfTransmissionDetailPage';
import LoadingPage from '../../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute(
  '/_authenticated/submissions/$submissionId',
)({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: CarfTransmissionDetailPage,
  staticData: {
    configPageId: 'submissions',
    meta: {
      title: 'Submission detail | Ledgible',
    },
  },
});
